import { IPixelCustomDataParameters } from '@faire/web-api--source/indigofair/data/IPixelCustomDataParameters';
import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey = 'cart-add_to_cart-click';

/**
 * Send FB Pixel event when user adds to their cart
 */
export function trackCartAddToCartClick(
  pixelCustomDataParams?: IPixelCustomDataParameters
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: true,
    facebookPixelEvent: 'AddToCart',
    pixelCustomDataParams,
  });
}
